import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import Hub from '../Hub/Hub'
import Articles from '../Articles/Articles'
import Menu from './Menu/Menu';
import Footer from './Footer/Footer';
import UpdateNotification from './UpdateNotification/UpdateNotification';

import AddToHome from './AddToHome/AddToHome'

// import globalJson from '../../data/global.json';

//style css
import classes from './App.module.scss';
const globalImages = require.context('../../images/components/Global', true, /.*\.(gif|png|jpe?g|svg)$/i);


class App extends Component {

	constructor(){

		super()
		
		//Force external links to open in-app to avoid breaking user experience
		var eventHandler = function (event) {
			// Only run for iOS full screen apps
			if (('standalone' in window.navigator) && window.navigator.standalone) {
				// Only run if link is an anchor and points to the current page
				if ( event.target.tagName.toLowerCase() !== 'a' || event.target.hostname !== window.location.hostname || event.target.pathname !== window.location.pathname || !/#/.test(event.target.href) ) return;
		
				// Open link in same tab
				event.preventDefault();
				window.location = event.target.href;
			}
		}

		window.addEventListener('click', eventHandler, false);

		this.state = {
			windowSize: 'desktop'
		}

	}

	componentDidMount() {
		this.resize();
		window.onresize = this.resize.bind(this);
	}
	
	resize() {
		if (window.innerWidth < 768) {
			this.setState({windowSize: 'mobile'});
		} else if(window.innerWidth < 1200) {
			this.setState({windowSize: 'tablet'});
		} else {
			this.setState({windowSize: 'desktop'});
		}
	}
	
	render() {
		return (

			<Router>
				<div>
					
					<Menu globalImages={globalImages} />
					
					<div className={`App ${classes.App}`}>
						<UpdateNotification/>
						
							<Switch>
								<Route exact path={`${process.env.PUBLIC_URL}(/index.html|/)`} render={(props) => <Hub globalImages={globalImages} windowSize={this.state.windowSize} {...props} /> } />
								<Route path={`*/:articleTitle`} render={(props) => 
								
									<Articles globalImages={globalImages} windowSize={this.state.windowSize} {...props} >

									</Articles>
									
								}/>
							</Switch>
							
					</div>
					<AddToHome />
					<Footer />
					
				</div>
			</Router>
			
		);
  }
}

export default App;